import { Field } from "react-final-form"

import { Radio, RadioGroupControl } from "@trueskin-web/components"
import { required } from "@trueskin-web/functions"
import { useTranslation } from "@trueskin-web/translations"

const Salution = ({ fieldName }) => {
  const { t } = useTranslation()

  //TODO: trueskin.atlassian.net/browse/AC-111
  return (
    <Field
      data-testid="web-portal-shipping-form-gender"
      name={fieldName}
      component={RadioGroupControl}
      type="input"
      isInline
      required
      validate={required}
      label={t("Start.Questionnaire.gender")}
      sx={{
        "& input ~ div": {
          borderColor: "textLight",
        },
      }}
    >
      <Radio value="herr" size="md">
        {t("Generic.genders.title.male")}
      </Radio>
      <Radio value="frau" size="md" sx={{ ml: 2 }}>
        {t("Generic.genders.title.female")}
      </Radio>
    </Field>
  )
}

export default Salution
